import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import PositionSlider from './Dashboard/DashboardContent/Positions/PositionSlider/PositionSlider'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'

export const TabItem = styled(Box)(({ theme, active}) => ({
	alignItems: 'center',
	background: theme.palette.mode === 'dark' ?
		(active ? '#3D414F' : 'transparent') :
		(active ? '#FFFFFF' : 'transparent'),
	borderRadius: '4px',
	color: theme.palette.mode === 'dark' ?
		(active ? '#FFFFFF' : '#6B6F77') :
		(active ? '#131635' : '#7C8EA6'),
	cursor: 'pointer',
	display: 'flex',
	height: '32px',
	justifyContent: 'center',
	minWidth: '125px',
	transition: '0.5s',
	padding: '8px',
	textAlign: 'center',
	[theme.breakpoints.down('xxl')]: {
		minWidth: '120px'
	}
}))

function AppTabs({tabsArray, setActiveTab, defaultActive, sxCustom, slider, parentWidth}) {
	const [active, setActive] = useState('')
	const [activeIndex, setActiveIndex] = useState(null)
	const { theme, xlDown, t } = useDefaultComponentTools()
	const handleTab = (title, index) => {
		setActive(title)
		setActiveTab(title)
		setActiveIndex(index)
	}
	useEffect(() => {
		setActive(defaultActive)
		setActiveIndex(
			tabsArray.findIndex((item) => item.id === defaultActive)
		)
	}, [defaultActive])

	return (
		<Box sx={{ mb: xlDown ? 1.5 : 3, width: 'fit-content', ...sxCustom }}>
			<Box sx={{ '.swiper': {padding: '0 50px'}, background: theme.palette.second, borderRadius: '4px',
				display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between',
				padding: '4px' }}>
				{slider && parentWidth <= slider && tabsArray.length > 1 ?
					<PositionSlider activeIndex={activeIndex} handleTab={handleTab} tabs={tabsArray} /> :
					(tabsArray.length > 0 ? (tabsArray.map((item, index) => <TabItem
						key={index}
						active={active === item.id ? 1 : 0}
						onClick={() => handleTab(item.id, index)}
					>
						<Typography>
							{t(item.label)}
						</Typography>
					</TabItem>)) : null)
				}
			</Box>
		</Box>
	)
}

AppTabs.propTypes = {
	defaultActive: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	parentWidth: PropTypes.number,
	setActiveTab: PropTypes.func,
	slider: PropTypes.number,
	sxCustom: PropTypes.object,
	tabsArray: PropTypes.array
}
export default AppTabs

